export default __webpack_public_path__ + "data/OPSight_User_Guide.pdf";